var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetherlands(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.031h30v6.563H0V7.03z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.313 0H4.688C1.58 0 0 2.309 0 5.156v1.875h30V5.156C30 2.31 28.419 0 25.312 0z",
    fill: "#EC1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.469c0 2.847 1.581 5.156 4.688 5.156h20.625c3.106 0 4.687-2.309 4.687-5.156v-1.875H0v1.875z",
    fill: "#1B75BB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlands);
export default ForwardRef;